import React from 'react';

import Section from 'components/Section/Section';

import translationsJson from 'data/translations.json';

const translations: Translations = translationsJson;


interface Props {
    page: string;
    tab: string;
}

export default class Indication extends React.Component{
    render() {
       return (
          <Section>
              <h4>{translations.indicationTitle[window.lang]}</h4>
              <p style={{ textAlign: "justify" }}>{translations.indicationText[window.lang]}</p>
              <p style={{ fontStyle: "italic" }}>{ translations.indicationSource[window.lang] }</p>
          </Section>
    )}
}